import { BroadcastAction, LogoutBroadcastMessage } from '@globalTypes/index';
import { LOGOUT_CHANNEL } from '@utils/constants';

/**
 * Triggers a logout broadcast message.
 * @param {string} detail - Additional details to include in the message.
 */
export const triggerLogoutMessage = (detail: string) => {
  const bc = new BroadcastChannel(LOGOUT_CHANNEL);
  const message: LogoutBroadcastMessage = { action: BroadcastAction.Logout, detail };
  bc.postMessage(message);
  bc.close();
};
